<template>
    <div class="OrderManagement">
        <div class="header">
            <el-row>
                <el-col :span="8">
                    <label class="headerlabel">用户信息</label>
                    <el-input v-model="param.searchValue" placeholder="请输入用户ID/昵称/手机号" class="autowidth" clearable></el-input>
                </el-col>
                <el-col :span="8">
                    <label class="headerlabel">订单类型</label>
                    <el-select v-model="param.orderType" placeholder="请选择" filterable  class="autowidth" clearable >
                        <el-option v-for="item in OrderTypeList" :label="item.label" :kye="item.value" :value="item.value"></el-option>
                        
                    </el-select>
                </el-col>
                <el-col :span="8">
                    <label class="headerlabel">支付时间</label>
                    <el-date-picker
                    class="autowidth"
                    clearable
                    v-model="Finalpaymenttime"
                    type="daterange"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                    </el-date-picker>
                    <el-button type="primary" style="margin-left: 24px;" @click="init">筛选</el-button>
                    <el-button @click="reset">重置条件</el-button>
                </el-col>
            </el-row>
        </div>

        <main class="MainContent">
            <el-table
            :data="OrderManagement"
            v-loading="loading"
            element-loading-text="拼命加载中"
            element-loading-spinner="el-icon-loading"
            style="width: 100%;margin-bottom: 20px;">
                <el-table-column prop="userID" label="用户ID"></el-table-column>
                <el-table-column label="头像">
                    <template slot-scope="scope">
                        <img v-if="scope.row.zHeadPhotoURL" :src="scope.row.zHeadPhotoURL" style="width: 40px;height: 40px;border-radius: 50%;">
                    </template>
                </el-table-column>
                <el-table-column prop="realName" label="用户昵称"></el-table-column>
                <el-table-column prop="phone" label="手机号码"></el-table-column>
                <el-table-column prop="orderType" label="订单类型"></el-table-column>
                <el-table-column prop="paidContent" label="付费内容"></el-table-column>
                <el-table-column prop="money" label="累计消费"></el-table-column>
                <el-table-column prop="state" label="订单状态"></el-table-column>
                <el-table-column prop="createdDate" label="支付时间"></el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button v-if="scope.row.state=='退款拒绝' || scope.row.state=='已退款'" type="text" style="margin-right: 10px;" @click="ClickAudit(scope.row)">详情</el-button>
                        <el-button v-if="scope.row.state=='退款审核中'" type="text" style="margin-right: 10px;" @click="ClickAudit(scope.row)">审批</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <el-pagination
            :hide-on-single-page=true
            @current-change="handleinitialization"
            :current-page.sync="param.pageNum"
            :page-size="param.pageSize"
            layout="total, prev, pager, next"
            :total="param.PageTotal">
        </el-pagination>
        </main>

        <el-dialog
            title="申请退单"
            :visible.sync="dialogVisible"
            width="480px"
            center
            :before-close="handleClose">
            <div class="product">
                <div class="product_img">
                    <el-image :src="OrderDetail.coverURL" fit="cover" style="height: 100%;">
                        <div slot="error" class="image-slot">
                            <i class="el-icon-picture-outline"></i>
                        </div>
                    </el-image>
                </div>
                <div class="product_detail">
                    <p class="product_name">{{OrderDetail.paidContent}}</p>
                    <p class="product_price">￥{{OrderDetail.fee}}</p>
                </div>
            </div>
            <p>审核意见</p>
            <div class="Audit">
                <el-input v-model="reasonRefund" type="textarea" maxlength="500" show-word-limit placeholder="请输入审核意见" :disabled="state=='退款拒绝' || state=='已退款'"></el-input>
            </div>
            <div style="text-align: center;margin: 20px 0 10px;">
                <el-button type="danger" @click="agree(7)" :disabled="state=='退款拒绝' || state=='已退款'">拒绝</el-button>
                <el-button type="primary" @click="agree(8)" :disabled="state=='退款拒绝' || state=='已退款'">同意</el-button>
            </div>
        </el-dialog>

    </div>
</template>
<script>
export default{
    data() {
        return {
            Finalpaymenttime:[],
            loading:false,
            OrderDetail:'',
            tradeNo:'',
            reasonRefund:'',
            param:{
                pageNum:1,
                pageSize:10,
                PageTotal:0,
                searchValue: "",
                orderType: "",
                endOrderTime: "",
                startOrderTime: "",
                endAddTime: ""
            },
            state:'',
            OrderManagement:[],
            OrderTypeList:[
                {label:'测评',value:1},
                {label:'咨询',value:2},
                {label:'会员',value:3},
                {label:'团体诉求',value:4},
            ],
            dialogVisible:false
        }
    },
    watch:{
        Finalpaymenttime(newval,oldval){
            if(newval==null){
                this.param.startOrderTime=''
                this.param.endOrderTime=''
            }else{
                this.param.startOrderTime=newval[0]
                this.param.endOrderTime=newval[1]
            }
        },
    },
    mounted() {
        this.init();
    },
    methods:{
        init(){
            this.loading=true;
            this.$Http_Post('/operate/order/list',this.param).then(res=>{
                this.loading=false;
                if(res.Code==0){
                    this.param.PageTotal=res.Counts;
                    this.OrderManagement=res.Data;
                    
                }else{
                    this.$message.error(res.Message);
                }
            })
        },
        reset(){
            this.param=this.$options.data().param;
            this.init();
        },
        handleinitialization(val){
            this.param.pageNum=val;
            this.init();
        },
        // 审批
        ClickAudit(val){
            this.tradeNo=val.tradeNo;
            this.state=val.state;
            let params={
                    orderType:val.state,//订单类型
                    objectID:val.objectID,
                    tradeNo:val.tradeNo//订单号
                }
            this.$Http_Post('/operate/order/orderDetails',params).then(res=>{
                if(res.Code==0){
                    this.OrderDetail=res.Data;
                    this.reasonRefund=res.Data.closeReason;
                    this.dialogVisible=true;
                }else{
                    this.$message.error(res.Message);
                }
            })
            
        },
        handleClose(){
            this.dialogVisible=false;
        },
        agree(val){
            this.$Http_Post('/operate/order/examine',{operate:val,tradeNo:this.tradeNo,reasonRefund:this.reasonRefund}).then(res=>{
                if(res.Code==0 || res.Code==200){
                    this.dialogVisible=false;
                    this.reasonRefund='';
                    this.$message.success(res.Message);
                    this.init();
                }else{
                    this.$message.error(res.Message);
                }
            })
        },
    },
}
</script>
<style>
.OrderManagement .header{background: #fff;padding:20px;}
.OrderManagement .header .headerlabel{width:90px;display: inline-block;}
.OrderManagement .header .autowidth{width: 240px;}
.OrderManagement .MainContent{background: #fff;padding:20px 16px;margin:16px 0;}
.OrderManagement .product{background:#F0F0F0;border-radius: 4px;display: flex;padding: 15px;overflow: hidden;margin-bottom: 15px;}
.OrderManagement .product .product_img{width: 80px;border-radius: 8px;height: 60px;margin-right: 15px;}
.OrderManagement .product .product_price{color: #FF5733;}
.OrderManagement .product .product_detail{display: flex;flex-direction: column;justify-content: space-between;}
.OrderManagement .Audit{background:#F0F0F0;border-radius: 4px;padding: 5px 0;margin: 10px 0 0;}
.OrderManagement .Audit textarea{background: none!important;border: none;}
.OrderManagement .Audit .el-input__count{background: none;}
</style>